<script lang="ts" setup>
import type { ApiOfficeserviceOffices } from '~~/server/api/officeservice/offices'
export interface WidgetOfficesMapProps {
    data: ApiOfficeserviceOffices
}

const { $t } = useNuxtApp()
const route = useRoute()
const router = useRouter()

const title = $t('Pobočky')
const payWithCard = $t('Platba kartou')
const openOnly = $t('Len otvorené')

// Accessibility: aria-live region for announcing checkbox state changes (WCAG 4.1.2, 1.3.1)
const checkboxStatusAnnouncement = ref<string>('')

const { data, sendEvent } = useTracker()

const { data: dataOffices, pending } = useLazyFetch(
    () =>
        `/api/officeservice/offices?query=${
            route.query.query || ''
        }&per_page=100000&s=${route.query.s || 1}&card_pay=${
            route.query.card_pay || ''
        }&open_only=${route.query.open_only || ''}&lat=${
            route.query.lat || ''
        }&lng=${route.query.lng || ''}`
)

const position = computed<string>(() => {
    if (data.position) {
        return `${data.position} / ${title}`
    }

    return title
})

const handleFilterChange = async (e: Event): Promise<void> => {
    const target = e.target as HTMLInputElement
    const query: { [key: string]: any } = {}

    query[target.id] = target.checked

    // Accessibility: Announce checkbox state change BEFORE route change (WCAG 4.1.2, 1.3.1)
    // Using non-breaking space trick to force DOM change detection
    checkboxStatusAnnouncement.value = '\u00A0'

    await router.push({ query: { ...route.query, ...query, s: 1 }, hash: route.hash })

    sendEvent({
        data: {
            ...data,
            position: position.value,
            title,
            click: target.dataset.title || '',
        },
    })
}
</script>

<template>
  <OfficesMap
    v-if="dataOffices"
    key="widget-office-map"
    :position="position"
    :title="title"
    :title-modal="$t('Pobočka')"
    :pending="pending"
    :data="dataOffices"
    named-route-key="office-detail"
    map-height="64rem"
    type="offices"
  >
    <div class="d-flex flex-wrap gap-5">
      <label class="d-flex align-items-center gap-2">
        <input
          id="card_pay"
          type="checkbox"
          name="card_pay"
          :data-title="payWithCard"
          :checked="route.query.card_pay === 'true'"
          @change="handleFilterChange"
        >
        {{ payWithCard }}
      </label>
      <label class="d-flex align-items-center gap-2">
        <input
          id="open_only"
          type="checkbox"
          name="open_only"
          :data-title="openOnly"
          :checked="route.query.open_only === 'true'"
          @change="handleFilterChange"
        >
        {{ openOnly }}
      </label>
    </div>
  </OfficesMap>
</template>
